import da from "element-ui/src/locale/lang/da";

export const useResponse = data => {
  console.log("useResponse", data);
  const oldUrl = data.config.oldUrl;
  if (data.data.data) {
    data.data = data.data.data;
  }

  if (/^\/advertisement/.test(oldUrl)) {
    const putLocationId = data.config.params.putLocationId;
    const path = data.config.params.path;
    if ([2, 3].includes(putLocationId)) {
      if (putLocationId == 2) {
        data.data = data.data.map(_ => {
          return {
            exhibit: {
              ..._
            }
          };
        });
      }
      if (putLocationId == 3) {
        data.data = data.data.map(_ => {
          return {
            exhibitor: {
              ..._
            }
          };
        });
      }
    }
    if ([1, 4, 5].includes(putLocationId)) {
      data.data = data.data.map(_ => {
        return {
          ..._,
          picture: _.pictures
        };
      });
    }
    if (path) {
      data.data = data.data
        .map(_ => {
          return {
            type: "EXHIBIT",
            category: {
              id: "7"
            },
            ..._,
            picture: _.pictures
          };
        })
        .filter(_ => _.picture);
      console.log(data.data, "///");
    }
  }

  if (/^\/exhibits/.test(oldUrl)) {
    console.log(1234567890);
    console.log(data);
    if (data.config.url.indexOf("/web/getHotExhibits") > -1) {
      data.data = {
        content: data.data.map(_ => {
          return {
            ..._,
            exhibitor: {
              name: data.data.exhibitorName,
              nameEn: data.data.exhibitorNameEn
            }
          };
        })
      };
    } else {
      data.data = {
        content: data.data.content.map(_ => {
          return {
            ..._,
            exhibitor: {
              name: data.data.exhibitorName,
              nameEn: data.data.exhibitorNameEn
            }
          };
        })
      };
    }
  }

  if (/^\/exhibit-category/.test(oldUrl)) {
    data.data = data.data.map(_ => {
      return {
        ..._,
        name: _.content,
        nameEn: _.contentEn,
        ...(_.properties || {})
      };
    });
  }

  // if (/^\/articles/.test(oldUrl)) {
  //   data.data = {
  //     content: data.data.map(_ => {
  //       return {
  //         ..._,
  //         title: _.name,
  //         link: _.linkContent,
  //         type: "LINK"
  //       };
  //     })
  //   };
  // }

  return data;
};



// WEBPACK FOOTER //
// ./src/api-map/response.js